<template>
  <v-row
    class="full-area pa-0 ma-0"
    v-bind:style="{
      backgroundImage: 'url(' + site.bg_url + ')',
      backgroundColor: site.color,
    }"
    style="
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    "
  >
    <div style="position: absolute; right: 10px; top: 10px; z-index: 1">
      <SelectLangauge />
    </div>

    <v-col cols="12" class="d-flex align-center justify-center">
      <v-card
        class="rounded-xl"
        elevation="10"
        style="width: 100%; max-width: 420px"
      >
        <v-container>
          <div class="pa-7 pa-sm-12">
            <v-row no-gutters>
              <v-col cols="12">
                <div>
                  <v-col class="d-flex justify-center mb-0">
                    <v-img
                      max-height="160"
                      max-width="225"
                      :src="site.logo_url"
                    ></v-img>
                  </v-col>
                  <h2
                    class="mt-6 mb-2 blue-grey--text text--darken-2 text-letf"
                  >
                    {{ $t("welcome") }}
                  </h2>
                </div>

                <v-window touchless v-model="step">
                  <v-window-item :value="1">
                    <v-form
                      ref="formRegister"
                      v-model="valid"
                      lazy-validation
                      class="justify-center"
                      @submit.prevent="checkUserIsExit()"
                    >
                      <v-col class="pa-0">
                        <template v-if="key_login_type == 'phone'">
                          <p
                            class="blue-grey--text text--darken-2 text-left"
                            style="font-size: smaller"
                          >
                            {{ $t("pleaseFill") }}
                            <span style="font-weight: bold">{{
                              $t("phone")
                            }}</span>
                          </p>
                          <v-text-field
                            :color="site.color"
                            v-model="mobile"
                            :rules="phoneRules"
                            :placeholder="$t('phone')"
                            class="mt-4 rounded-lg"
                            maxlength="15"
                            type="number"
                            oninput="this.value=this.value.slice(0,this.maxLength)"
                            required
                            dense
                            outlined
                          ></v-text-field>
                        </template>
                        <template v-if="key_login_type == 'email'">
                          <p
                            class="blue-grey--text text--darken-2 text-left"
                            style="font-size: smaller"
                          >
                            {{ $t("pleaseFill") }}
                            <span style="font-weight: bold">{{
                              $t("email")
                            }}</span>
                          </p>
                          <v-text-field
                            :color="site.color"
                            v-model="email"
                            :rules="emailRules"
                            :placeholder="$t('email')"
                            class="mt-4 rounded-lg"
                            required
                            dense
                            outlined
                          ></v-text-field>
                        </template>
                      </v-col>
                      <v-col class="text-center pa-0">
                        <v-btn
                          class="text-center white--text rounded-lg"
                          :disabled="!valid"
                          :color="site.color"
                          @click="checkUserIsExit()"
                        >
                          {{ $t("confirm") }}
                        </v-btn>
                      </v-col>
                    </v-form>
                  </v-window-item>
                </v-window>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import SelectLangauge from "../../../components/selectLangauge.vue";
import { getLandingPage } from "../../../config/general-function.js";

export default {
  components: { SelectLangauge },
  inject: ["isAppLoading"],
  data: () => ({
    valid: true,
    loading: false,
    mobile: "",
    step: 1,
    OTP: "",
    request_id: "",
    ref_code: "",
    key_login_type: "phone",
    email: "",
  }),

  methods: {
    checkUserIsExit() {
      if (!this.$refs.formRegister.validate(true)) {
        return;
      }
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .get(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/checkUserIsExist?mobile=${this.mobile}`
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.login();
          }
          if (res.data.status == "not_found") {
            this.$swal.fire({
              icon: "error",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else if (res.data.status == "not_registered") {
            localStorage.setItem("mobile", this.mobile);
            this.redirectRegister();
            // this.$swal
            //   .fire({
            //     icon: "error",
            //     text: res.data.message,
            //     showCancelButton: false,
            //     confirmButtonText: this.$t("registerPage"),
            //   })
            //   .then((result) => {
            //     if (result.isConfirmed) {
            //       localStorage.setItem("mobile", this.mobile);
            //       this.redirectRegister();
            //     }
            //   });
          }
        })
        .catch((err) => {
          console.log("err :>> ", err);
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    login() {
      this.loading = true;
      let token = localStorage.getItem("token");

      this.isAppLoading(true);
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE + `/loginWithOutOtp`,
          {
            mobile: this.mobile,
            email: this.email,
            token: token,
          }
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal
              .fire({
                icon: "success",
                text: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                let customer = {
                  ...(res.data.data.employee || {}),
                  status_consent: true,
                };
                this.$store.commit("defaultSystem/SET_CUSTOMER", customer);
                if (res.data.data.is_confirm_register == false) {
                  this.$store.commit(
                    "defaultSystem/SET_CONDITION",
                    res.data.data.terms_of_service.text
                  );
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                } else {
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                }
              });
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
      this.loading = false;
    },
    async setToken(accessToken) {
      return new Promise((resolve) => {
        localStorage.setItem("token", accessToken);
        resolve();
      });
    },

    redirectRegister() {
      if (this.site?.register_detail) {
        let target = this.site?.register_detail.is_blank ? "_blank" : "_self";
        if (
          this.site?.register_detail.url !== null &&
          this.site?.register_detail.is_source_external == true
        ) {
          window.open(this.site?.register_detail.url, target);
        } else {
          this.$router.push({
            name: "register-bypass",
          });
        }
      } else {
        this.$router.push({
          name: "register-bypass",
        });
      }
    },
  },

  computed: {
    ...mapState("defaultSystem", ["site"]),
    phoneRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) =>
          /^(08|06|09)\d{8}$/.test(v) || this.$t("validation.phoneInvalid"),
      ];
    },
    emailRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("validation.emailInvalid"),
      ];
    },
    otpRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) => /^[0-9]/.test(v) || this.$t("validation.numberInvalid"),
      ];
    },
  },
};
</script>

<style>
.full-area {
  color: rgba(0, 0, 0, 0.87);
}
.position-relative {
  position: relative;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
